const riskfied = (() => {
    return () => (next: Function) => (action: any) => {
        switch (action.type) {
            case '@@router/LOCATION_CHANGE':
                // @ts-ignore
                if (typeof window !== 'undefined' && window.RISKX) {
                    const { pathname, search } = action.payload;
                    // @ts-ignore
                    window.RISKX.go(`${pathname}${search}`);
                }

                break;
            default:
                break;
        }
        return next(action);
    };
})();

export default riskfied;
